import { getGridSingleSelectOperators, getGridStringOperators } from '@mui/x-data-grid-premium';

const allStringOperators = getGridStringOperators();
const allSingleSelectOperators = getGridSingleSelectOperators();

function filterOperatorsByValue(operators, values) {
  return operators.filter(op => values.includes(op.value));
}

function filterOutOperatorsByValue(operators, values) {
  return operators.filter(op => !values.includes(op.value));
}

export const containsOnly = filterOperatorsByValue(allStringOperators, ['contains']);

export const allStringOperatorsExceptIsEmptyAndIsNotEmpty = filterOutOperatorsByValue(allStringOperators, [
  'isEmpty',
  'isNotEmpty'
]);

export const containsIsEmptyIsNotEmptyIsAnyOf = filterOperatorsByValue(allStringOperators, [
  'contains',
  'isEmpty',
  'isNotEmpty',
  'isAnyOf'
]);

export const isEmptyIsNotEmptyIsAnyOf = filterOperatorsByValue(allStringOperators, [
  'isEmpty',
  'isNotEmpty',
  'isAnyOf'
]);

export const containsIsEmptyIsNotEmpty = filterOperatorsByValue(allStringOperators, [
  'contains',
  'isEmpty',
  'isNotEmpty'
]);

export const singleSelectIs = filterOperatorsByValue(allSingleSelectOperators, ['is']);

export const singleSelectIsIsAnyOf = filterOperatorsByValue(allSingleSelectOperators, ['is', 'isAnyOf']);

export const singleSelectIsIsNotIsAnyOf = filterOperatorsByValue(allSingleSelectOperators, ['is', 'not', 'isAnyOf']);
